import { AuthRequestModel } from './auth-request';
import { LoginBaseModel } from './login-base-model';

export interface GoogleLoginRequestModel extends AuthRequestModel {
  id_token: string;
}

export class GoogleLoginModel extends LoginBaseModel {
  constructor(idToken: string) {
    super();
    this.token = idToken;
  }

  static toJSON(value: GoogleLoginModel): GoogleLoginRequestModel {
    return {
      id_token: value.token,
      version: value.version,
      group_invite_mode: value.groupInviteMode,
      group_invite_key: value.groupInviteKey,
      group_code_mode: value.groupCodeMode,
      group_code: value.groupCode,
      group_ovid_mode: value.groupOvidMode,
      group_ovid_osptok: value.groupOvidOsptok,
      // optoinal platform params
      platform: value.platform,
      return_to: value.returnTo,
      brand_id: value.brandId,
      locale_id: value.localeId,
      timestamp: value.timestamp,
      // verification
      site_verify_response: value.site_verify_response,
    };
  }
}
